<div class="pb-3 w-full block relative z-[2]">
	<div class="bg-white lg:p-5 py-4 px-5 flex flex-wrap items-center justify-between relative z-10">
		<div class="content__logo flex flex-wrap items-center gap-3 sm:pl-5 pl-4">
			<div class="lg:hidden block">
				<a href="javascript:void(0);" class="btn__sidebar md:text-2xl text-xl block w-[25px] h-[25px]">
					<i class="fa-light fa-bars-sort"></i>
				</a>
			</div>
			<h5 class="2xl:block xl:hidden lg:hidden hidden max-w-full block m-auto text-xl font__title font-semibold"><span class="font-bold">Configuración</span> - <span>{{ (data$ | async)?.title }}</span></h5>
			<a href="javascript:void(0)" (click)="back()" class="flex gap-1 items-center justify-center">
				<i class="fa-regular fa-circle-left"></i> <span class="md:block hidden leading-none">Volver</span>
			</a>
			<!-- <a href="javascript:void(0)" routerLink="{{ back_location ? back_location : '/' }}"><i class="fa-regular fa-circle-left"></i> Volver</a> -->
		</div>

		<div class="w-auto max-w-full">
			<ul class="list-none flex flex-wrap items-center gap-2">
				<li class="relative dropdown_contnt">
          {{ userName }}
          <!-- <a routerLink="/dashboard/notifications" href="javascript:void(0)" class="lg:hidden flex text-[color:var(--primary-color)] text-lg bg-gray-100 py-2 px-2 rounded-full transition-all duration-300 ease-in-out hover:bg-[color:var(--primary-color)] hover:text-white">
						<span class="w-[22px] relative before:pb-[100%] before:block">
							<i class="fa-light fa-bell absolute top-[50%] left-[50%] -translate-x-1/2 -translate-y-1/2"></i>
						</span>
					</a> -->
					<!-- <button mat-button [matMenuTriggerFor]="notificationsDropdown" class="lg:flex hidden text-[color:var(--primary-color)] text-lg bg-gray-100 py-2 px-2 rounded-full transition-all duration-300 ease-in-out hover:bg-[color:var(--primary-color)] hover:text-white">
						<span class="w-[22px] relative before:pb-[100%] before:block">
							<i class="fa-light fa-bell absolute top-[50%] left-[50%] -translate-x-1/2 -translate-y-1/2"></i>
						</span>
					</button> -->
					<mat-menu #notificationsDropdown="matMenu" class="w-[400px] !max-w-full">
						<div class="py-5 px-4 whitespace-nowrap">
							<div class="w-full block mb-4">
								<div class="w-full border-b-[1px] border-b-gray-300">
									<div class="grid grid-cols-2 items-center gap-2 pb-2 px-4 w-full">
										<div class="col-span-1 w-full block">
											<h5 class="font__title text-xl text-left">Notificaciones</h5>
										</div>
										<div class="col-span-1 w-full block text-right">
											<div routerLink="/dashboard/notifications" class="p-2 cursor-pointer text-sky-500">
												<i class="fa-duotone fa-right"></i>
											</div>
										</div>
									</div>
								</div>
							</div>
							<ul class="w-full grid grid-cols-1 gap-2 overflow-y-scroll max-h-[350px] scrollbar_css min_bar">
								<ng-container *ngIf="xServices.lengthItems(notifications); else elseNotifications">
									<li class="w-full" *ngFor="let item of notifications">
										<a href="javascript:void(0)" class="py-2 px-4 w-full grid grid-cols-[minmax(0,50px)_minmax(0,1fr)] gap-4 items-center transition-all rounded bg-transparent hover:bg-gray-50 ">
											<div class="w-full block">
												<div class="w-full block relative before:block before:pb-[100%]">
													<span class="absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2">
														<i class="fa-solid fa-bell-on text-[2rem] text-emerald-400"></i>
													</span>
												</div>
											</div>
											<div class="w-full block">
												<div class="w-full grid grid-cols-2 gap-2 items-center">
													<div class="col-span-1 w-full block">
														<p class="text-xs text-gray-400 ">{{ xServices.formatDate(item['date']) }}</p>
													</div>
													<div class="col-span-1 w-full block text-right">
														<p class="text-xs text-gray-400 ">{{ item['time'] ? item['time'] : '00:00' }}</p>
													</div>
												</div>
												<div class="w-full block">
													<h5 class="block w-full text-base font-bold text-gray-600 m-0 leading-none font__title">{{ item['name'] }}</h5>
													<div class="block w-full text-sm font__title" [innerHtml]="item['message']"></div>
												</div>
											</div>
										</a>
									</li>
									<li class="w-full block">
										<button routerLink="/dashboard/notifications" class="w-full block py-2 px-4 bg-transparent text-gray-600 border border-gray-200 rounded appearance-none leading-none hover:bg-sky-50 hover:text-sky-400 transition-all">Ver Todos</button>
									</li>
								</ng-container>
								<ng-template #elseNotifications>
									<li class="w-full">
										<p>No se encontrarón notificaciones</p>
									</li>
								</ng-template>
							</ul>
						</div>
					</mat-menu>
				</li>

				<ng-container *ngIf="user$ | async as _data">
					<li class="relative" *ngIf="_data.website['current_organization']">
						<button mat-button [matMenuTriggerFor]="organizationDropdown" class="text-gray-800 text-lg py-2 px-4 inline-flex flex-wrap items-center relative before:w-full before:h-full before:transition-all before:duration-300 before:ease-in-out before:absolute before:top-1/2 before:left-1/2 before:-translate-y-1/2 before:-translate-x-1/2 before:scale-50 before:bg-gray-100 before:rounded-xl before:z-[-1] before:opacity-0 hover:before:opacity-100 hover:before:scale-100">
							<div class="w-[40px] h-[22px] relative">
								<img [src]="_data.website['current_organization']['image'] ? _data.website['current_organization']['image'] :'/assets/img/demo.png'" [alt]="_data.website['current_organization']['name']" class="w-full h-full absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 object-center object-scale-down">
							</div>
							<span class="sm:flex sm:flex-col hidden">
								<span class="text-sm block leading-[normal] font-semibold">{{ _data.website['current_organization']['name'] }}</span>
								<span class="text-[13px] block leading-[normal]">Organización</span>
							</span>
							<small><i class="fa-light fa-angle-down sm:ml-[8px]"></i></small>
						</button>
						<mat-menu #organizationDropdown="matMenu">
							<ul class="py-3 px-2 whitespace-nowrap">
								<ng-container *ngIf="xServices.lengthItems(_data.website['organizations']); else elseOrganizations">
									<li class="w-full" *ngFor="let organization of _data.website['organizations']">
										<button type="button" (click)="changeOrganization(organization['id'])" class="text-gray-800 text-base py-2 px-4 inline-flex items-center relative w-full hover:bg-gray-50">
											<div class="w-[40px] h-[22px] relative">
												<img [src]="organization['image_url'] ? organization['image_url'] : '/assets/img/demo.png'" [alt]="organization['name']" class="w-full h-full absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 object-center object-scale-down">
											</div>
											<span>{{ organization['name'] }}</span>
										</button>
									</li>
								</ng-container>
								<ng-template #elseOrganizations>
									<li class="w-full">
										<p>No se encontrarón organizaciones afiliadas</p>
									</li>
								</ng-template>
							</ul>
						</mat-menu>
					</li>
				</ng-container>
				<li class="relative">
					<button mat-button [matMenuTriggerFor]="userDropdown" class="text-gray-800 text-lg py-2 px-4 inline-flex flex-wrap items-center relative before:w-full before:h-full before:transition-all before:duration-300 before:ease-in-out before:absolute before:top-1/2 before:left-1/2 before:-translate-y-1/2 before:-translate-x-1/2 before:scale-50 before:bg-gray-100 before:rounded-xl before:z-[-1] before:opacity-0 hover:before:opacity-100 hover:before:scale-100">
						<i class="fa-light fa-user mr-[5px] w-[22px]"></i>
						<span class="sm:flex sm:flex-col hidden">
							<ng-container *ngIf="!authService.isLoggedIn(); else elseAuth1">
								<span class="text-sm block leading-[normal] font-semibold">Inicia sesión</span>
								<span class="text-[13px] block leading-[normal]">Dashboard</span>
							</ng-container>
							<ng-template #elseAuth1>
								<ng-container *ngIf="user$ | async as _user">
									<span class="text-sm block leading-[normal] font-semibold">{{ _user.first_name+' '+_user.last_name }}</span>
									<span class="text-[13px] block leading-[normal]">Dashboard</span>
								</ng-container>
							</ng-template>
						</span>
						<small><i class="fa-light fa-angle-down sm:ml-[8px]"></i></small>
					</button>
					<mat-menu #userDropdown="matMenu">
						<ul class="py-5 px-4 whitespace-nowrap">
							<ng-container *ngIf="!authService.isLoggedIn(); else elseAuth2">
								<li class="w-full">
									<a href="javascript:void(0)" routerLink="/auth" class="text-gray-800 text-base py-2 px-4 inline-flex items-center relative w-full before:transition-all before:duration-300 before:ease-in-out before:absolute before:left-4 before:w-0 before:bottom-0 before:border-b-2 before:border-b-[color:var(--primary-color)] hover:before:w-[50%]">
										<i class="fa-light fa-arrow-right-to-bracket mr-[5px] text-base w-[20px]"></i>
										<span>Iniciar sesión</span>
									</a>
								</li>
							</ng-container>
							<ng-template #elseAuth2>
								<!-- <li class="w-full">
									<a href="javascript:void(0)" routerLink="/dashboard/account" class="text-gray-800 text-base py-2 px-4 inline-flex items-center relative w-full before:transition-all before:duration-300 before:ease-in-out before:absolute before:left-4 before:w-0 before:bottom-0 before:border-b-2 before:border-b-[color:var(--primary-color)] hover:before:w-[50%]">
										<i class="fa-light fa-file-user mr-[5px] text-base w-[20px]"></i>
										<span>Mi Perfil</span>
									</a>
								</li>
								<li class="w-full">
									<a href="javascript:void(0)" routerLink="/dashboard/account-security" class="text-gray-800 text-base py-2 px-4 inline-flex items-center relative w-full before:transition-all before:duration-300 before:ease-in-out before:absolute before:left-4 before:w-0 before:bottom-0 before:border-b-2 before:border-b-[color:var(--primary-color)] hover:before:w-[50%]">
										<i class="fa-light fa-shield-check mr-[5px] text-base w-[20px]"></i>
										<span>Seguridad</span>
									</a>
								</li>
								<li class="w-full">
									<a href="javascript:void(0)" routerLink="/dashboard/organizaciones" class="text-gray-800 text-base py-2 px-4 inline-flex items-center relative w-full before:transition-all before:duration-300 before:ease-in-out before:absolute before:left-4 before:w-0 before:bottom-0 before:border-b-2 before:border-b-[color:var(--primary-color)] hover:before:w-[50%]">
										<i class="fa-light fa-grid mr-[5px] text-base w-[20px]"></i>
										<span>Organizaciones</span>
									</a>
								</li>
								<li class="w-full">
									<button [matMenuTriggerFor]="servicesDropdown" mat-menu-item class="text-gray-800 text-base py-2 px-4 inline-flex items-center relative w-full before:transition-all before:duration-300 before:ease-in-out before:absolute before:left-4 before:w-0 before:bottom-0 before:border-b-2 before:border-b-[color:var(--primary-color)] hover:before:w-[50%]">
										<i class="fa-light fa-clipboard-list mr-[5px] text-base w-[20px]"></i>
										<span>Documentación</span>
										<small><i class="fa-light fa-angle-down sm:ml-[8px]"></i></small>
									</button>
									<mat-menu class="date-range-menu" #servicesDropdown="matMenu">
										<ul class="py-5 px-4 bg-gray-50">
											<li>
												<a href="javascript:void(0)" routerLink="/documentation" class="text-gray-800 text-base py-2 px-4 inline-flex gap-2 items-center relative w-full before:transition-all before:duration-300 before:ease-in-out before:absolute before:left-4 before:w-0 before:bottom-0 before:border-b-2 before:border-b-[color:var(--primary-color)] hover:before:w-[50%]">
													<i class="fa-duotone fa-angles-right"></i>
													<span>Documentación</span>
												</a>
											</li>
											<ng-container *ngIf="xServices.lengthItems(services); else elseServices">
												<li *ngFor="let service of services">
													<a href="javascript:void(0)" [routerLink]="['/documentation/intro', slugChange(service['name'])]" class="text-gray-800 text-base py-2 px-4 inline-flex gap-2 items-center relative w-full before:transition-all before:duration-300 before:ease-in-out before:absolute before:left-4 before:w-0 before:bottom-0 before:border-b-2 before:border-b-[color:var(--primary-color)] hover:before:w-[50%]">
														<i class="fa-duotone fa-angles-right"></i>
														<span>{{ service['name'] }}</span>
													</a>
													<a href="javascript:void(0)" [routerLink]="['/documentation', service['id']]" class="text-gray-800 text-base py-2 px-4 inline-flex gap-2 items-center relative w-full before:transition-all before:duration-300 before:ease-in-out before:absolute before:left-4 before:w-0 before:bottom-0 before:border-b-2 before:border-b-[color:var(--primary-color)] hover:before:w-[50%]">
														<i class="fa-duotone fa-angles-right"></i>
														<span>{{ service['name'] }}</span>
													</a>
												</li>
											</ng-container>
											<ng-template #elseServices>
												<li>
													<p>No se encontrarón servicios dentro de la documentation</p>
												</li>
											</ng-template>
										</ul>
									</mat-menu>
								</li> -->
								<li class="w-full">
									<a href="javascript:void(0)" (click)="logout()" class="text-gray-800 text-base py-2 px-4 inline-flex items-center relative w-full before:transition-all before:duration-300 before:ease-in-out before:absolute before:left-4 before:w-0 before:bottom-0 before:border-b-2 before:border-b-[color:var(--primary-color)] hover:before:w-[50%]">
										<i class="fa-light fa-arrow-right-from-bracket mr-[5px] text-base w-[20px]"></i>
										<span>Cerrar Sesión</span>
									</a>
								</li>
							</ng-template>
						</ul>
					</mat-menu>
				</li>
			</ul>
		</div>
	</div>
</div>
